import * as Sentry from '@sentry/vue'
import store from '@/vuex/store'
import router from '@/router'

let initOffice = false

const loadDataFromSlidePowerPoint = async (key) => {
  if (!window.Office) return null
  if (!window.Office.context) return null
  if (!window.Office.context.host) return null
  if (window.Office.context.platform === 'OfficeOnline') {
    store.commit('setIsOfficeOnline', true)
  }
  store.commit('setAddinPPTPlatform', window.Office.context.platform)
  return new Promise((resolve, reject) => {
    window.Office.context.document.settings.refreshAsync((asyncResult) => {
      if (asyncResult.status === window.Office.AsyncResultStatus.Failed) {
        reject()
      } else {
        const ahaSlideId = window.Office.context.document.settings.get(key)
        if (ahaSlideId !== null) {
          resolve(ahaSlideId)
        } else {
          resolve()
        }
      }
    })
  })
}

const setDataSlideInPowerpointToState = (ahaPresentationId, ahaSlideId) => {
  store.state.powerPointPresentationId = ahaPresentationId
  store.state.powerPointSlideId = ahaSlideId
}

const setDataPresentationInPowerpointToState = (ahaPresentationId) => {
  store.state.activePresentationPowerpointId = ahaPresentationId
}

const handleDataAfterLoadOffice = async () => {
  const dataSlidePPT = await loadDataFromSlidePowerPoint('dataSlidePPT')
  if (dataSlidePPT && dataSlidePPT.activePresentationId) {
    setDataPresentationInPowerpointToState(dataSlidePPT.activePresentationId)
    if (window.location.href.indexOf('/pages/login') !== -1 || window.location.href.indexOf('/pages/register') !== -1) {
      return
    }
    if (window.location.href.indexOf('/presentation/') === -1) {
      router.replace({
        name: 'PresentationDetail',
        params: { id: dataSlidePPT.activePresentationId },
        query: { presenting: true, 'ppt-presentation': true },
      })
    }
    return
  }
  if (dataSlidePPT && dataSlidePPT.slideId && dataSlidePPT.presentationId) {
    setDataSlideInPowerpointToState(dataSlidePPT.presentationId, dataSlidePPT.slideId)
    if (window.location.href.indexOf('/presentation/') === -1) {
      if (window.location.href.indexOf('/pages/login') !== -1 || window.location.href.indexOf('/pages/register') !== -1) {
        return
      }
      router.replace({
        name: 'PresentationDetail',
        params: { id: dataSlidePPT.presentationId },
        query: { presenting: true },
      })
    }
  }
}

const reCheckActiveView = () => {
  window.Office?.context?.document?.getActiveViewAsync((result) => {
    store.commit('setActiveViewMode', result.value)
  })
}

const detectActiveViewChange = () => {
  window.Office?.context?.document?.addHandlerAsync(
    window.Office.EventType.ActiveViewChanged,
    (args) => {
      store.commit('setActiveViewMode', args.activeView)
    },
  )
  reCheckActiveView()
}

const handleOnLoadOffice = async () => {
  initOffice = true
  if (window.Office && window.Office.context && window.Office.context.host) {
    store.state.isPowerPointAddIn = true
    if (window._historyCache) {
      window.history.replaceState = window._historyCache.replaceState
      window.history.pushState = window._historyCache.pushState
      window.history.back = window._historyCache.back
    }
    handleDataAfterLoadOffice()
    detectActiveViewChange()
  }
}

const loadOffice = async () => {
  try {
    // Office.js replaces the default Window.history methods of replaceState and pushState with null. This is done to support older Microsoft webviews and Office versions.
    // But our PowerPoint add-in needs PowerPoint 2019+, which is fully compatible with the new browser APIs.
    // This is the workaround to restore the original methods.
    window._historyCache = {
      replaceState: window.history.replaceState,
      pushState: window.history.pushState,
      back: window.history.back,
    }
    if (window.Office) {
      return window.Office
    }
    const loadOfficePromise = async () => {
      return new Promise((resolve, reject) => {
        const script1 = document.createElement('script')
        script1.onload = () => {
          const resolveOffice = async () => {
            if (!initOffice) {
              console.log('loaded office')
              await handleOnLoadOffice()
              resolve(window.Office)
            }
          }
          window.Office.onReady(() => {
            resolveOffice()
          })
          setTimeout(async () => {
            resolveOffice()
          }, 2000)
        }
        script1.onerror = reject
        script1.src = 'https://appsforoffice.microsoft.com/lib/1/hosted/office.js'
        document.head.appendChild(script1)
      })
    }
    await loadOfficePromise()
    return window.Office
  } catch (error) {
    Sentry.captureException(error)
    return null
  }
}

const saveDataToSlidePowerPoint = async (key, value) => {
  if (window.Office && window.Office.context && window.Office.context.host) {
    window.Office.context.document.settings.set(key, value)
    if (!value) {
      window.Office.context.document.settings.remove(key)
      window.Office.context.document.settings.set(key, '')
      window.Office.context.document.settings.saveAsync(() => {
      })
    }
    return new Promise((resolve, reject) => {
      window.Office.context.document.settings.saveAsync((asyncResult) => {
        if (asyncResult.status === window.Office.AsyncResultStatus.Failed) {
          reject()
        } else {
          resolve()
        }
      })
    })
  }
  return null
}

export default {
  loadOffice,
  saveDataToSlidePowerPoint,
  loadDataFromSlidePowerPoint,
  setDataSlideInPowerpointToState,
  setDataPresentationInPowerpointToState,
  handleDataAfterLoadOffice,
  reCheckActiveView,
}
